import React, { Component } from "react";
import generateContentDataObject from "../../helpers/editor/generateContentDataObject";
import { callToActionOptions } from "../../data/callToActionOptions";
import { buttonStyles } from "../../data/buttonStyles";
import { linkOrButtonOptions } from "../../data/linkOrButtonOptions";
import { pictogramOptions } from "../../data/pictogramOptions";
import { pricingItemDetailIconOptions } from "../../data/pricingItemDetailIconOptions";
import isNumericOrDashOrPlus from "../../helpers/editor/isNumericOrDashOrPlus";
import { displayTitleMarkupText } from "../../helpers/content_displayers/displayTitleMarkupText";
import { displaySubtitleMarkupText } from "../../helpers/content_displayers/displaySubtitleMarkupText";
import Emoji from "../component_molecules/Emoji";
import Pictogram from "../component_molecules/Pictogram";
import WebsiteButton from "../component_molecules/WebsiteButton";
import WebsiteCTA from "../component_molecules/WebsiteCTA";
import TitleBox from "../component_molecules/TitleBox";
import { checkIfPricingTabsAreHidden } from "../../helpers/pricing/checkIfPricingTabsAreHidden";
import { checkIfPricingTabHasCustomText } from "../../helpers/pricing/checkIfPricingTabHasCustomText";

interface Props {
  componentItem: any;
  checkIsEmptyContent: any;
  saveContentInStore: any;
  connectDefaultFormIntegration: any; //we need this to connect an integration to forms in CTAs
  isDarkBg: boolean;
}

class Pricing02 extends Component<Props> {
  generator = new generateContentDataObject();
  randomIndex = Math.floor(Math.random() * 9999); //because each Pricing component needs a unique index to switch the 'monthly/yearly' tabs.

  componentWillMount(): void {
    const { isDefaultEmpty } = this.props.componentItem;
    //check if the component has not content (when just added). if so, generate some default dummy content.
    // also change inputs tooltips, placeholders text if needed. E.g. when a component needs an image of a particular size.
    if (this.props.checkIsEmptyContent()) {
      //generate defaultContent{}. Use special methods of the generateContentDataObject class;

      this.props.saveContentInStore(
        this.generator.setUpTitle({
          titleText: "Affordable Pricing for Everyone",
          isDefaultEmpty
        })
      );
      this.props.saveContentInStore(
        this.generator.setUpSubtitleText({
          subtitleText:
            "No nickel & dime. Raptus silva una contactuss mortem est. Cum assimilatio crescere, omnes absolutioes reperire rusticus, ferox burguses.",
            isDefaultEmpty
        })
      );

      this.props.saveContentInStore(
        this.generator.setUpCta({
          isDefaultEmpty,
          activeOption: callToActionOptions.buttons,
          fieldTitle: {
            [callToActionOptions.buttons]: "Bottom buttons",
            default: "Bottom buttons",
          },
          label: {
            [callToActionOptions.buttons]: "Edit the buttons:",
            default: "Edit the buttons:",
          },
          labelTooltip: {
            [callToActionOptions.buttons]:
              "Add a CTA (call to action) to the bottom of the pricing component to offer more ways to get your product. E.g. a sales contact link.",
            default:
              "Add a CTA (call to action) to the bottom of the pricing component to offer more ways to get your product. E.g. a sales contact link.",
          },

          buttons: [
            this.generator.createButtonContentObject({
              buttonType: linkOrButtonOptions.link,
              buttonTitle: "",
              buttonHref: "",
              buttonStyleType: buttonStyles.pill.typeTitle,
              pillPrefix: "BTW",
            }),
          ],

          priority: 10,
        })
      );

      this.props.saveContentInStore(
        this.generator.setUpPricing({
          isDefaultEmpty,
          maxItems: 64,
          hasHighlight: true,
          hasSecondaryInfo: false,
          hasEditableIcon: false,
          hasDetailsSet: true,
          items: [
            this.generator.createPricingContentObject({
              title: "Freelancer",
              primaryInfo: "Perfect for beginners",
              pictogram: this.generator.createPictogramContentObject({
                type: pictogramOptions.emoji.title,
                emojiSrc: "1f6f4.svg",
              }),
              monthlyPrice: 9,
              button: this.generator.createButtonContentObject({
                buttonType: linkOrButtonOptions.link,
                buttonTitle: "Start now",
                buttonHref: "#",
                buttonStyleType: buttonStyles.regular.typeTitle,
                buttonColor: buttonStyles.regular.accentOutline,
                buttonIsTargetBlank: true,
              }),
              detailsSet: [
                this.generator.createPricingItemDetailContentObject({
                  title: "1 workspace",
                  icon: pricingItemDetailIconOptions.greenTick,
                  hoverInfo: "",
                }),
                this.generator.createPricingItemDetailContentObject({
                  title: "1 agent",
                  icon: pricingItemDetailIconOptions.greenTick,
                  hoverInfo: "",
                }),
                this.generator.createPricingItemDetailContentObject({
                  title: "All integrations",
                  icon: pricingItemDetailIconOptions.greenTick,
                  hoverInfo: "",
                }),

                this.generator.createPricingItemDetailContentObject({
                  title: "Mobile apps",
                  icon: pricingItemDetailIconOptions.redCross,
                  hoverInfo: "",
                }),
                this.generator.createPricingItemDetailContentObject({
                  title: "Premium support",
                  icon: pricingItemDetailIconOptions.redCross,
                  hoverInfo: "",
                }),

                this.generator.createPricingItemDetailContentObject({
                  title: "",
                }), //ghost item
              ],
            }),
            this.generator.createPricingContentObject({
              title: "Team",
              isHighlighted: true,
              primaryInfo: "For small teams",
              pictogram: this.generator.createPictogramContentObject({
                type: pictogramOptions.emoji.title,
                emojiSrc: "1f5a5.svg",
              }),
              monthlyPrice: 19,
              button: this.generator.createButtonContentObject({
                buttonType: linkOrButtonOptions.link,
                buttonTitle: "Start now",
                buttonHref: "#",
                buttonStyleType: buttonStyles.regular.typeTitle,
                buttonColor: buttonStyles.regular.accentBg,
                buttonIsTargetBlank: true,
              }),
              detailsSet: [
                this.generator.createPricingItemDetailContentObject({
                  title: "5 workspaces",
                  icon: pricingItemDetailIconOptions.greenTick,
                  hoverInfo: "",
                }),
                this.generator.createPricingItemDetailContentObject({
                  title: "5 agents",
                  icon: pricingItemDetailIconOptions.greenTick,
                  hoverInfo: "",
                }),
                this.generator.createPricingItemDetailContentObject({
                  title: "All integrations",
                  icon: pricingItemDetailIconOptions.greenTick,
                  hoverInfo: "",
                }),

                this.generator.createPricingItemDetailContentObject({
                  title: "Mobile apps",
                  icon: pricingItemDetailIconOptions.greenTick,
                  hoverInfo: "",
                }),
                this.generator.createPricingItemDetailContentObject({
                  title: "Premium support",
                  icon: pricingItemDetailIconOptions.redCross,
                  hoverInfo: "",
                }),

                this.generator.createPricingItemDetailContentObject({
                  title: "",
                }), //ghost item
              ],
            }),

            this.generator.createPricingContentObject({
              title: "Business",
              primaryInfo: "For huge companies",
              pictogram: this.generator.createPictogramContentObject({
                type: pictogramOptions.emoji.title,
                emojiSrc: "1f4bc.svg",
              }),
              monthlyPrice: 49,
              button: this.generator.createButtonContentObject({
                buttonType: linkOrButtonOptions.link,
                buttonTitle: "Start now",
                buttonHref: "#",
                buttonStyleType: buttonStyles.regular.typeTitle,
                buttonColor: buttonStyles.regular.accentOutline,
                buttonIsTargetBlank: true,
              }),
              detailsSet: [
                this.generator.createPricingItemDetailContentObject({
                  title: "90 workspaces",
                  icon: pricingItemDetailIconOptions.greenTick,
                  hoverInfo: "",
                }),
                this.generator.createPricingItemDetailContentObject({
                  title: "60 agents",
                  icon: pricingItemDetailIconOptions.greenTick,
                  hoverInfo: "",
                }),
                this.generator.createPricingItemDetailContentObject({
                  title: "All integrations",
                  icon: pricingItemDetailIconOptions.greenTick,
                  hoverInfo: "",
                }),

                this.generator.createPricingItemDetailContentObject({
                  title: "Mobile apps",
                  icon: pricingItemDetailIconOptions.greenTick,
                  hoverInfo: "",
                }),
                this.generator.createPricingItemDetailContentObject({
                  title: "Premium support",
                  icon: pricingItemDetailIconOptions.greenTick,
                  hoverInfo: "",
                }),

                this.generator.createPricingItemDetailContentObject({
                  title: "",
                }), //ghost item
              ],
            }),
          ],
        })
      );
    }
  }

  render() {
    // these variables contain content. we need to wait a little before content schemes with default data will be populated (it happens on the componentWillMount even, each time we launch generator).
    // see the content schema in the helpers/editor/generateContentDataObject.ts
    let title = displayTitleMarkupText(
      this.props.componentItem.componentData.title.content.markup
    );
    let subtitleText = displaySubtitleMarkupText(
      this.props.componentItem.componentData.subtitleText.content.markup
    );

    let pricing = this.props.componentItem.componentData.pricing;

    const { randomIndex } = this;

    let isYearlyTabActiveByDefault = pricing.isYearlyActiveByDefault;
    // we added this property on 11 Sep 2020, so it if undefined for old components
    if (isYearlyTabActiveByDefault === undefined) {
      isYearlyTabActiveByDefault = false;
    }

    return (
      <section>
        <div className="pricing-02">
          <TitleBox
            title={title}
            subtitleText={subtitleText}
            isDarkBg={this.props.isDarkBg}
          />
          <div className="container">
            {pricing.content.items[0] &&
            pricing.content.items[0].yearlyPrice !== "" &&
            !checkIfPricingTabsAreHidden(pricing) && ( //if the first pricing item has a yearly price, then display the switcher.
                <div className="pricing-02__buttons">
                  <ul className="pricing-02__buttons_list">
                    <li className="tab">
                      <button
                        className={
                          "content-text def-12 tab__button js-open-tab " +
                          (isYearlyTabActiveByDefault === false
                            ? " state-active-tab"
                            : "")
                        }
                        type="button"
                        data-index="monthly-price-1"
                        data-group={"my-pricing-group-" + randomIndex}
                        dangerouslySetInnerHTML={{__html: checkIfPricingTabHasCustomText(pricing, "left") ? pricing.leftTabText : "Monthly"}}
                      />
                    </li>
                    <li className="tab">
                      <button
                        className={
                          "content-text def-12 tab__button js-open-tab " +
                          (isYearlyTabActiveByDefault
                            ? " state-active-tab"
                            : "")
                        }
                        type="button"
                        data-index="yearly-price-1"
                        data-group={"my-pricing-group-" + randomIndex}
                        dangerouslySetInnerHTML={{__html: checkIfPricingTabHasCustomText(pricing, "right") ? pricing.rightTabText : "Yearly"}}
                      />
                    </li>
                  </ul>
                  <div
                    className={
                      "pricing-02__badge js-tab-content " +
                      (isYearlyTabActiveByDefault ? " state-active-tab" : "")
                    }
                    data-index="yearly-price-1"
                    data-group={"my-pricing-group-" + randomIndex}
                  >
                    {pricing.yearlyBonusText && pricing.yearlyBonusText !== "" && (
                      <span className="pointed-badge   pointed-badge--acid-bg pointed-badge--left">
                        <span className="pointed-badge__text" dangerouslySetInnerHTML={{__html: pricing.yearlyBonusText}} />
                        <Emoji
                          emojiSrc="1f381.svg"
                          className="emoji"
                          alt="Emoji Gift"
                        />
                      </span>
                    )}
                  </div>
                </div>
              )}
          </div>
          <div className="container">
            <div className="pricing-02__cards_container">
              <ul className="pricing-02__cards_list">
                {pricing.content.items &&
                  pricing.content.items.map((item: any, key: number) => {
                    let displayDetailsSet = (pricingObject: any) => {
                      let detailsSet = pricingObject.detailsSet;

                      if (detailsSet.length === 0) {
                        return null;
                      } else {
                        const detailsItemsJSX = detailsSet.map(
                          (detailItem: any, detailKey: any) => {
                            if (detailItem.title && detailItem.title !== "") {
                              return (
                                <li
                                  className="pricing-02__info_item"
                                  key={"details-item_pricing-02-" + detailKey}
                                >
                                  <div className="pricing-02__info_item_box">
                                    <div className="pricing-02__info_item_text content-text" dangerouslySetInnerHTML={{__html: detailItem.title}} />

                                    {detailItem.hoverInfo &&
                                      detailItem.hoverInfo !== "" && (
                                        <div className="pricing-02__info_item_icon js-hover-to-show-sibling">
                                          <span className="icon">
                                            <svg
                                              width="16px"
                                              height="16px"
                                              viewBox="0 0 16 16"
                                              version="1.1"
                                              xmlns="http://www.w3.org/2000/svg"
                                            >
                                              <g
                                                id="Symbols"
                                                stroke="none"
                                                strokeWidth="1"
                                                fill="none"
                                                fillRule="evenodd"
                                              >
                                                <g
                                                  id="Help-icon"
                                                  fill="#4D61FC"
                                                  className="fill-main"
                                                >
                                                  <g id="help">
                                                    <path
                                                      d="M7.7549375,10.725625 C7.29746875,10.725625 6.92709375,11.106875 6.92709375,11.564375 C6.92709375,12.0109687 7.2865625,12.403125 7.7549375,12.403125 C8.2233125,12.403125 8.5936875,12.011 8.5936875,11.564375 C8.5936875,11.106875 8.21246875,10.725625 7.7549375,10.725625 Z"
                                                      id="Shape"
                                                      fillRule="nonzero"
                                                    />
                                                    <path
                                                      d="M5.18339825,6.43681645 C5.18339825,6.09664548 5.29260939,5.75200375 5.51103497,5.40288091 C5.72946054,5.05375807 6.04814225,4.76461708 6.46708965,4.53544927 C6.88603706,4.30628145 7.3748017,4.19169927 7.93339825,4.19169927 C8.45260657,4.19169927 8.91093532,4.28748281 9.30839825,4.47905278 C9.70586117,4.67062275 10.0129056,4.93111819 10.2295408,5.26054692 C10.446176,5.58997565 10.554492,5.94804499 10.554492,6.33476567 C10.554492,6.63912917 10.492725,6.90589083 10.3691893,7.13505864 C10.2456535,7.36422645 10.0988451,7.56205976 9.92875957,7.7285645 C9.75867409,7.89506924 9.45341998,8.17525849 9.01298809,8.56914067 C8.89124269,8.68014383 8.7936688,8.77771773 8.72026348,8.86186528 C8.64685817,8.94601284 8.59225259,9.02299775 8.55644512,9.09282231 C8.52063765,9.16264688 8.49288728,9.2324704 8.47319317,9.30229497 C8.45349906,9.37211954 8.42395834,9.49475828 8.38457012,9.67021489 C8.31653593,10.0426126 8.10348467,10.2288086 7.74540997,10.2288086 C7.55921112,10.2288086 7.40255578,10.1679369 7.27543926,10.0461915 C7.14832274,9.92444605 7.08476543,9.74362104 7.08476543,9.50371099 C7.08476543,9.20292823 7.13131445,8.94243279 7.22441387,8.72221684 C7.3175133,8.5020009 7.44104722,8.30864346 7.59501934,8.14213872 C7.74899146,7.97563398 7.95667168,7.77780067 8.21806622,7.54863286 C8.44723403,7.34811102 8.6128411,7.19682673 8.71489239,7.09477544 C8.81694368,6.99272415 8.90288032,6.87903713 8.97270489,6.75371099 C9.04252946,6.62838484 9.07744122,6.49231849 9.07744122,6.34550786 C9.07744122,6.05904809 8.97091559,5.81735129 8.75786114,5.6204102 C8.54480669,5.42346912 8.26998847,5.32500005 7.93339825,5.32500005 C7.53951607,5.32500005 7.24947991,5.42436429 7.06328106,5.62309575 C6.87708221,5.82182721 6.7195317,6.1145489 6.59062481,6.50126958 C6.46887941,6.905894 6.23792469,7.10820317 5.89775372,7.10820317 C5.69723188,7.10820317 5.52804412,7.03748448 5.39018536,6.89604497 C5.25232659,6.75460546 5.18339825,6.60153082 5.18339825,6.43681645 Z M7.804492,12.3235352 C7.58606643,12.3235352 7.3953945,12.2528165 7.23247051,12.111377 C7.06954652,11.9699375 6.98808575,11.7721042 6.98808575,11.5178711 C6.98808575,11.2922841 7.066861,11.1025073 7.22441387,10.9485352 C7.38196674,10.7945631 7.57532418,10.7175782 7.804492,10.7175782 C8.03007906,10.7175782 8.21985581,10.7945631 8.37382793,10.9485352 C8.52780006,11.1025073 8.60478497,11.2922841 8.60478497,11.5178711 C8.60478497,11.7685234 8.52421936,11.9654616 8.36308575,12.1086915 C8.20195213,12.2519213 8.01575607,12.3235352 7.804492,12.3235352 Z"
                                                      id="?"
                                                    />
                                                    <path
                                                      d="M8,0 C3.578625,0 -8.8812421e-16,3.57803125 -8.8812421e-16,8 L5.42101086e-20,15.4799995 C5.42101086e-20,15.825187 0.174812481,16 0.519999981,16 L8,16 C12.4213438,16 16,12.4219687 16,8 C16,3.578625 12.4219687,0 8,0 Z M8,14.75 L1.25,14.75 L1.25,8 C1.25,4.26946875 4.26896875,1.25 8,1.25 C11.7305313,1.25 14.75,4.26896875 14.75,8 C14.75,11.7305313 11.7310312,14.75 8,14.75 Z"
                                                      id="Shape"
                                                      fillOpacity="0.300000012"
                                                      fillRule="nonzero"
                                                    />
                                                  </g>
                                                </g>
                                              </g>
                                            </svg>
                                          </span>
                                        </div>
                                      )}
                                    {detailItem.hoverInfo &&
                                      detailItem.hoverInfo !== "" && (
                                        <div className="content-text pricing-02__hover js-content-to-show" dangerouslySetInnerHTML={{__html: detailItem.hoverInfo}} />
                                      )}
                                  </div>
                                </li>
                              );
                            } else {
                              return null;
                            }
                          }
                        );

                        return (
                          <ul className="pricing-02__info">
                            {detailsItemsJSX}
                          </ul>
                        );
                      }
                    };

                    if (
                      item.monthlyPrice !== undefined &&
                      item.monthlyPrice !== ""
                    ) {
                      //Empty string ('') when no price is entered by a user.
                      let isEnteredMonthlyAmountNumeric = isNumericOrDashOrPlus(
                        item.monthlyPrice
                      ); // we hide the currency symbol and period for non-numeric values (e.g. "contact us")

                      let monthlyPriceClass = " ";
                      let monthlyPriceStringLength = item.monthlyPrice.toString()
                        .length;
                      if (monthlyPriceStringLength === 3) {
                        monthlyPriceClass =
                          " pricing-02__price_text smaller-text-09 ";
                      } else if (monthlyPriceStringLength === 4) {
                        monthlyPriceClass =
                          " pricing-02__price_text smaller-text-08 ";
                      } else if (monthlyPriceStringLength === 5) {
                        monthlyPriceClass =
                          " pricing-02__price_text smaller-text-07 ";
                      } else if (monthlyPriceStringLength === 6) {
                        monthlyPriceClass =
                          " pricing-02__price_text smaller-text-06 ";
                      } else if (monthlyPriceStringLength === 7) {
                        monthlyPriceClass =
                          " pricing-02__price_text smaller-text-05 ";
                      } else if (monthlyPriceStringLength === 8) {
                        monthlyPriceClass =
                          " pricing-02__price_text smaller-text-04 ";
                      } else if (monthlyPriceStringLength > 8) {
                        monthlyPriceClass =
                          " pricing-02__price_text smaller-text-04 ";
                      }

                      let yearlyPriceClass = " ";
                      let yearlyPriceStringLength = item.yearlyPrice.toString()
                        .length;
                      if (yearlyPriceStringLength === 3) {
                        yearlyPriceClass =
                          " pricing-02__price_text smaller-text-09 ";
                      } else if (yearlyPriceStringLength === 4) {
                        yearlyPriceClass =
                          " pricing-02__price_text smaller-text-08 ";
                      } else if (yearlyPriceStringLength === 5) {
                        yearlyPriceClass =
                          " pricing-02__price_text smaller-text-07 ";
                      } else if (yearlyPriceStringLength === 6) {
                        yearlyPriceClass =
                          " pricing-02__price_text smaller-text-06 ";
                      } else if (yearlyPriceStringLength === 7) {
                        yearlyPriceClass =
                          " pricing-02__price_text smaller-text-05 ";
                      } else if (yearlyPriceStringLength === 8) {
                        yearlyPriceClass =
                          " pricing-02__price_text smaller-text-04 ";
                      } else if (yearlyPriceStringLength > 8) {
                        yearlyPriceClass =
                          " pricing-02__price_text smaller-text-04 ";
                      }

                      let symbolClass = " ";
                      if (item.currencySymbol.length > 1) {
                        symbolClass = " pricing-02__price_symbol--bigger ";
                      }

                      return (
                        <li
                          className={
                            "sh-4 pricing-02__card_box card-container " +
                            (item.isHighlighted
                              ? " pricing-02__card_box--accent "
                              : "")
                          }
                          key={
                            "pricing-table-item-2-" + key + "-" + randomIndex
                          }
                        >
                          <div className="pricing-02__card">
                            {item.pictogram.type &&
                              item.pictogram.type !== "" && (
                                <Pictogram
                                  pictogramObject={item.pictogram}
                                  className="pricing-02__card_img"
                                />
                              )}

                            {item.title && item.title !== "" && (
                              <h3 className="def-22 title-text--inner pricing-02__card_title" dangerouslySetInnerHTML={{__html: item.title}} />
                            )}

                            {item.primaryInfo && item.primaryInfo !== "" && (
                              <div className="content-text def-14 pricing-02__card_info" dangerouslySetInnerHTML={{__html: item.primaryInfo}} />
                            )}

                            <div className="pricing-02__price_box">
                              <div
                                className={
                                  "pricing-02__price_item js-tab-content " +
                                  (isYearlyTabActiveByDefault === false
                                    ? " state-active-tab"
                                    : "")
                                }
                                data-index="monthly-price-1"
                                data-group={"my-pricing-group-" + randomIndex}
                              >
                                {isEnteredMonthlyAmountNumeric && (
                                  <div
                                    className={
                                      "content-text def-14 pricing-02__price_symbol " + symbolClass
                                    }
                                    dangerouslySetInnerHTML={{__html: item.currencySymbol}}
                                  />
                                )}
                                <div className="pricing-02__price content-text def-64">
                                  <span
                                    className={monthlyPriceClass}
                                    dangerouslySetInnerHTML={{
                                      __html: item.monthlyPrice,
                                    }}
                                  />
                                </div>
                                {isEnteredMonthlyAmountNumeric && (
                                  <div
                                    className="pricing-02__period content-text def-14"
                                    dangerouslySetInnerHTML={{
                                      __html: item.monthlyPeriod,
                                    }}
                                  />
                                )}
                              </div>
                              <div
                                className={
                                  "pricing-02__price_item js-tab-content " +
                                  (isYearlyTabActiveByDefault
                                    ? " state-active-tab"
                                    : "")
                                }
                                data-index="yearly-price-1"
                                data-group={"my-pricing-group-" + randomIndex}
                              >
                                {isEnteredMonthlyAmountNumeric && (
                                  <div
                                    className={
                                      "content-text def-14 pricing-02__price_symbol " + symbolClass
                                    }
                                    dangerouslySetInnerHTML={{__html: item.currencySymbol}}
                                  />
                                )}
                                <div className="pricing-02__price content-text def-64">
                                  <span
                                    className={yearlyPriceClass}
                                    dangerouslySetInnerHTML={{
                                      __html:
                                        item.yearlyPrice === ""
                                          ? "?"
                                          : item.yearlyPrice,
                                    }}
                                  />
                                </div>
                                {isEnteredMonthlyAmountNumeric && (
                                  <div
                                    className="pricing-02__period content-text def-14"
                                    dangerouslySetInnerHTML={{
                                      __html: item.yearlyPeriod,
                                    }}
                                  />
                                )}
                              </div>
                            </div>

                            {displayDetailsSet(item)}

                            <div className="pricing-02__card_button">
                              {item.button.title !== "" && (
                                <WebsiteButton
                                  config={{
                                    buttonStyleType:
                                      item.button.settings.appearance.styleType,
                                    buttonColor:
                                      item.button.settings.appearance.color,
                                    buttonType: linkOrButtonOptions.link,
                                    buttonTitle: item.button.title,
                                    buttonHref: item.button.href,
                                    buttonIsTargetBlank:
                                      item.button.isTargetBlank,
                                    pillPrefix: item.button.pillPrefix,
                                    pillColor:
                                      item.button.settings.appearance.pillColor,
                                    ghostColor:
                                      item.button.settings.appearance
                                        .ghostColor,
                                    buttonObject: item.button,
                                  }}
                                />
                              )}
                            </div>
                          </div>
                        </li>
                      );
                    }
                  })}
              </ul>
            </div>
          </div>

          <div className="bottom_cta">
            {this.props.componentItem.componentData.cta && (
              <WebsiteCTA componentItem={this.props.componentItem} />
            )}
          </div>
        </div>
      </section>
    );
  }
}

export default Pricing02;
